const locale = {
  id: 'ClassOneConstant',
  code: 'CN',
  text: {
    "./images/private_en@2x.png": "./images/Private_class@2x.png",
    'Flexible Private Class Management': '灵活多变的私课',
    'Private Class Management is not limited to just one on one lesson, it can also be used as auditions, interviews, and more. Just like Class Management, it allows you to appoint teacher and classrooms.': '私课不仅仅指一对一的教学形式，这里还可以用于补课，试听，对谈等多种应用方式。别忘了，老师，教室和授课时间也是影响私课的重要因素哦。',
  }
}

export const onBoardingContents = {
  // we show this when student state is 'current'
  current: {
    title: __('Flexible Private Class Management', locale),
    text: __('Private Class Management is not limited to just one on one lesson, it can also be used as auditions, interviews, and more. Just like Class Management, it allows you to appoint teacher and classrooms.', locale),
    image: require(__('./images/private_en@2x.png', locale)),
    showArrow: true,
  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/ClassOne/constant.js